// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Request from "../../core/Request.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as SiretInputField from "../../modules/SiretInputField.res.js";
import * as SupplierCivility from "../../modules/Supplier/SupplierCivility.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
import * as AddressComboBoxField from "../../modules/AddressComboBoxField.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation createSupplier($supplierInput: InputCreateSupplier!, $contactsInput: [InputCreateSupplierContact!], $locationsInput: [InputCreateSupplierLocation!])  {\ncreateSupplier(supplierInput: $supplierInput, contactsInput: $contactsInput, locationsInput: $locationsInput)  {\n__typename  \nid  \ncompanyName  \nintraCommunityVat  \nsiretNumber  \nphoneNumber  \nmobileNumber  \nemail  \nnote  \ninternalCode  \ncontacts  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nlastName  \nfirstName  \nposition  \nemail  \nphoneNumber  \nmobileNumber  \nisDefault  \ncivility  \n}\n\n}\n\n}\n\nlocations  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nlabel  \npostalCode  \ncity  \ncountry  \naddress  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.createSupplier;
  let value$2 = value$1.intraCommunityVat;
  let value$3 = value$1.siretNumber;
  let value$4 = value$1.phoneNumber;
  let value$5 = value$1.mobileNumber;
  let value$6 = value$1.email;
  let value$7 = value$1.note;
  let value$8 = value$1.internalCode;
  let value$9 = value$1.contacts;
  let value$10 = value$9.edges;
  let value$11 = value$1.locations;
  let value$12 = value$11.edges;
  return {
    createSupplier: {
      __typename: value$1.__typename,
      id: value$1.id,
      companyName: value$1.companyName,
      intraCommunityVat: !(value$2 == null) ? value$2 : undefined,
      siretNumber: !(value$3 == null) ? value$3 : undefined,
      phoneNumber: !(value$4 == null) ? value$4 : undefined,
      mobileNumber: !(value$5 == null) ? value$5 : undefined,
      email: !(value$6 == null) ? value$6 : undefined,
      note: !(value$7 == null) ? Scalar.Text.parse(value$7) : undefined,
      internalCode: !(value$8 == null) ? value$8 : undefined,
      contacts: {
        __typename: value$9.__typename,
        edges: value$10.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.firstName;
          let value$3 = value$1.position;
          let value$4 = value$1.email;
          let value$5 = value$1.phoneNumber;
          let value$6 = value$1.mobileNumber;
          let value$7 = value$1.civility;
          let tmp;
          if (value$7 == null) {
            tmp = undefined;
          } else {
            let tmp$1;
            switch (value$7) {
              case "MR" :
                tmp$1 = "MR";
                break;
              case "MRS" :
                tmp$1 = "MRS";
                break;
              case "NEUTRAL" :
                tmp$1 = "NEUTRAL";
                break;
              default:
                tmp$1 = {
                  NAME: "FutureAddedValue",
                  VAL: value$7
                };
            }
            tmp = tmp$1;
          }
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              lastName: value$1.lastName,
              firstName: !(value$2 == null) ? value$2 : undefined,
              position: !(value$3 == null) ? value$3 : undefined,
              email: !(value$4 == null) ? value$4 : undefined,
              phoneNumber: !(value$5 == null) ? value$5 : undefined,
              mobileNumber: !(value$6 == null) ? value$6 : undefined,
              isDefault: value$1.isDefault,
              civility: tmp
            }
          };
        })
      },
      locations: {
        __typename: value$11.__typename,
        edges: value$12.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.postalCode;
          let value$3 = value$1.city;
          let value$4 = value$1.country;
          let value$5 = value$1.address;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              label: value$1.label,
              postalCode: !(value$2 == null) ? value$2 : undefined,
              city: !(value$3 == null) ? value$3 : undefined,
              country: !(value$4 == null) ? value$4 : undefined,
              address: !(value$5 == null) ? value$5 : undefined
            }
          };
        })
      }
    }
  };
}

function serialize(value) {
  let value$1 = value.createSupplier;
  let value$2 = value$1.locations;
  let value$3 = value$2.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.address;
    let address = value$2 !== undefined ? value$2 : null;
    let value$3 = value$1.country;
    let country = value$3 !== undefined ? value$3 : null;
    let value$4 = value$1.city;
    let city = value$4 !== undefined ? value$4 : null;
    let value$5 = value$1.postalCode;
    let postalCode = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.label;
    let value$7 = value$1.__typename;
    let node = {
      __typename: value$7,
      label: value$6,
      postalCode: postalCode,
      city: city,
      country: country,
      address: address
    };
    let value$8 = value.__typename;
    return {
      __typename: value$8,
      node: node
    };
  });
  let value$4 = value$2.__typename;
  let locations = {
    __typename: value$4,
    edges: edges
  };
  let value$5 = value$1.contacts;
  let value$6 = value$5.edges;
  let edges$1 = value$6.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.civility;
    let civility = value$2 !== undefined ? (
        typeof value$2 === "object" ? value$2.VAL : (
            value$2 === "MR" ? "MR" : (
                value$2 === "MRS" ? "MRS" : "NEUTRAL"
              )
          )
      ) : null;
    let value$3 = value$1.isDefault;
    let value$4 = value$1.mobileNumber;
    let mobileNumber = value$4 !== undefined ? value$4 : null;
    let value$5 = value$1.phoneNumber;
    let phoneNumber = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.email;
    let email = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.position;
    let position = value$7 !== undefined ? value$7 : null;
    let value$8 = value$1.firstName;
    let firstName = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.lastName;
    let value$10 = value$1.__typename;
    let node = {
      __typename: value$10,
      lastName: value$9,
      firstName: firstName,
      position: position,
      email: email,
      phoneNumber: phoneNumber,
      mobileNumber: mobileNumber,
      isDefault: value$3,
      civility: civility
    };
    let value$11 = value.__typename;
    return {
      __typename: value$11,
      node: node
    };
  });
  let value$7 = value$5.__typename;
  let contacts = {
    __typename: value$7,
    edges: edges$1
  };
  let value$8 = value$1.internalCode;
  let internalCode = value$8 !== undefined ? value$8 : null;
  let value$9 = value$1.note;
  let note = value$9 !== undefined ? Scalar.Text.serialize(value$9) : null;
  let value$10 = value$1.email;
  let email = value$10 !== undefined ? value$10 : null;
  let value$11 = value$1.mobileNumber;
  let mobileNumber = value$11 !== undefined ? value$11 : null;
  let value$12 = value$1.phoneNumber;
  let phoneNumber = value$12 !== undefined ? value$12 : null;
  let value$13 = value$1.siretNumber;
  let siretNumber = value$13 !== undefined ? value$13 : null;
  let value$14 = value$1.intraCommunityVat;
  let intraCommunityVat = value$14 !== undefined ? value$14 : null;
  let value$15 = value$1.companyName;
  let value$16 = value$1.id;
  let value$17 = value$1.__typename;
  let createSupplier = {
    __typename: value$17,
    id: value$16,
    companyName: value$15,
    intraCommunityVat: intraCommunityVat,
    siretNumber: siretNumber,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    email: email,
    note: note,
    internalCode: internalCode,
    contacts: contacts,
    locations: locations
  };
  return {
    createSupplier: createSupplier
  };
}

function serializeInputObjectInputCreateSupplierLocation(inp) {
  let a = inp.recipient;
  let a$1 = inp.address;
  let a$2 = inp.postalCode;
  let a$3 = inp.city;
  let a$4 = inp.country;
  let a$5 = inp.defaults;
  return {
    label: inp.label,
    recipient: a !== undefined ? a : undefined,
    address: a$1 !== undefined ? a$1 : undefined,
    postalCode: a$2 !== undefined ? a$2 : undefined,
    city: a$3 !== undefined ? a$3 : undefined,
    country: a$4 !== undefined ? a$4 : undefined,
    defaults: a$5.map(b => {
      if (b === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    })
  };
}

function serializeInputObjectInputCreateSupplier(inp) {
  let a = inp.intraCommunityVat;
  let a$1 = inp.siretNumber;
  let a$2 = inp.phoneNumber;
  let a$3 = inp.mobileNumber;
  let a$4 = inp.email;
  let a$5 = inp.note;
  let a$6 = inp.internalCode;
  return {
    companyName: inp.companyName,
    intraCommunityVat: a !== undefined ? a : undefined,
    siretNumber: a$1 !== undefined ? a$1 : undefined,
    phoneNumber: a$2 !== undefined ? a$2 : undefined,
    mobileNumber: a$3 !== undefined ? a$3 : undefined,
    email: a$4 !== undefined ? a$4 : undefined,
    note: a$5 !== undefined ? a$5 : undefined,
    internalCode: a$6 !== undefined ? a$6 : undefined,
    shopId: inp.shopId
  };
}

function serializeInputObjectInputCreateSupplierContact(inp) {
  let a = inp.firstName;
  let a$1 = inp.position;
  let a$2 = inp.email;
  let a$3 = inp.phoneNumber;
  let a$4 = inp.mobileNumber;
  let a$5 = inp.civility;
  return {
    lastName: inp.lastName,
    firstName: a !== undefined ? a : undefined,
    position: a$1 !== undefined ? a$1 : undefined,
    email: a$2 !== undefined ? a$2 : undefined,
    phoneNumber: a$3 !== undefined ? a$3 : undefined,
    mobileNumber: a$4 !== undefined ? a$4 : undefined,
    isDefault: inp.isDefault,
    civility: a$5 !== undefined ? (
        a$5 === "MR" ? "MR" : (
            a$5 === "MRS" ? "MRS" : "NEUTRAL"
          )
      ) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.contactsInput;
  let a$1 = inp.locationsInput;
  return {
    supplierInput: serializeInputObjectInputCreateSupplier(inp.supplierInput),
    contactsInput: a !== undefined ? a.map(serializeInputObjectInputCreateSupplierContact) : undefined,
    locationsInput: a$1 !== undefined ? a$1.map(serializeInputObjectInputCreateSupplierLocation) : undefined
  };
}

function makeVariables(supplierInput, contactsInput, locationsInput, param) {
  return {
    supplierInput: supplierInput,
    contactsInput: contactsInput,
    locationsInput: locationsInput
  };
}

function makeInputObjectInputCreateSupplier(companyName, intraCommunityVat, siretNumber, phoneNumber, mobileNumber, email, note, internalCode, shopId, param) {
  return {
    companyName: companyName,
    intraCommunityVat: intraCommunityVat,
    siretNumber: siretNumber,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    email: email,
    note: note,
    internalCode: internalCode,
    shopId: shopId
  };
}

function makeInputObjectInputCreateSupplierContact(lastName, firstName, position, email, phoneNumber, mobileNumber, isDefault, civility, param) {
  return {
    lastName: lastName,
    firstName: firstName,
    position: position,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    isDefault: isDefault,
    civility: civility
  };
}

function makeInputObjectInputCreateSupplierLocation(label, recipient, address, postalCode, city, country, defaults, param) {
  return {
    label: label,
    recipient: recipient,
    address: address,
    postalCode: postalCode,
    city: city,
    country: country,
    defaults: defaults
  };
}

let CreateSupplierMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateSupplier: serializeInputObjectInputCreateSupplier,
  serializeInputObjectInputCreateSupplierContact: serializeInputObjectInputCreateSupplierContact,
  serializeInputObjectInputCreateSupplierLocation: serializeInputObjectInputCreateSupplierLocation,
  makeVariables: makeVariables,
  makeInputObjectInputCreateSupplier: makeInputObjectInputCreateSupplier,
  makeInputObjectInputCreateSupplierContact: makeInputObjectInputCreateSupplierContact,
  makeInputObjectInputCreateSupplierLocation: makeInputObjectInputCreateSupplierLocation
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CreateSupplierMutation_useWithVariables = include.useWithVariables;

let CreateSupplierMutation = {
  CreateSupplierMutation_inner: CreateSupplierMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateSupplier: serializeInputObjectInputCreateSupplier,
  serializeInputObjectInputCreateSupplierContact: serializeInputObjectInputCreateSupplierContact,
  serializeInputObjectInputCreateSupplierLocation: serializeInputObjectInputCreateSupplierLocation,
  makeVariables: makeVariables,
  makeInputObjectInputCreateSupplier: makeInputObjectInputCreateSupplier,
  makeInputObjectInputCreateSupplierContact: makeInputObjectInputCreateSupplierContact,
  makeInputObjectInputCreateSupplierLocation: makeInputObjectInputCreateSupplierLocation,
  use: use,
  useWithVariables: CreateSupplierMutation_useWithVariables
};

function get(values, field) {
  switch (field) {
    case "ShopId" :
      return values.shopId;
    case "CompanyName" :
      return values.companyName;
    case "Email" :
      return values.email;
    case "PhoneNumber" :
      return values.phoneNumber;
    case "MobileNumber" :
      return values.mobileNumber;
    case "IntraCommunityVat" :
      return values.intraCommunityVat;
    case "SiretNumber" :
      return values.siretNumber;
    case "InternalCode" :
      return values.internalCode;
    case "Note" :
      return values.note;
    case "ContactFirstName" :
      return values.contactFirstName;
    case "ContactLastName" :
      return values.contactLastName;
    case "ContactCivility" :
      return values.contactCivility;
    case "ContactPosition" :
      return values.contactPosition;
    case "ContactEmail" :
      return values.contactEmail;
    case "ContactPhoneNumber" :
      return values.contactPhoneNumber;
    case "ContactMobileNumber" :
      return values.contactMobileNumber;
    case "LocationLabel" :
      return values.locationLabel;
    case "LocationRecipient" :
      return values.locationRecipient;
    case "LocationAddress" :
      return values.locationAddress;
    case "LocationPostalCode" :
      return values.locationPostalCode;
    case "LocationCity" :
      return values.locationCity;
    case "LocationCountry" :
      return values.locationCountry;
  }
}

function set(values, field, value) {
  switch (field) {
    case "ShopId" :
      let newrecord = {...values};
      newrecord.shopId = value;
      return newrecord;
    case "CompanyName" :
      let newrecord$1 = {...values};
      newrecord$1.companyName = value;
      return newrecord$1;
    case "Email" :
      let newrecord$2 = {...values};
      newrecord$2.email = value;
      return newrecord$2;
    case "PhoneNumber" :
      let newrecord$3 = {...values};
      newrecord$3.phoneNumber = value;
      return newrecord$3;
    case "MobileNumber" :
      let newrecord$4 = {...values};
      newrecord$4.mobileNumber = value;
      return newrecord$4;
    case "IntraCommunityVat" :
      let newrecord$5 = {...values};
      newrecord$5.intraCommunityVat = value;
      return newrecord$5;
    case "SiretNumber" :
      let newrecord$6 = {...values};
      newrecord$6.siretNumber = value;
      return newrecord$6;
    case "InternalCode" :
      let newrecord$7 = {...values};
      newrecord$7.internalCode = value;
      return newrecord$7;
    case "Note" :
      let newrecord$8 = {...values};
      newrecord$8.note = value;
      return newrecord$8;
    case "ContactFirstName" :
      let newrecord$9 = {...values};
      newrecord$9.contactFirstName = value;
      return newrecord$9;
    case "ContactLastName" :
      let newrecord$10 = {...values};
      newrecord$10.contactLastName = value;
      return newrecord$10;
    case "ContactCivility" :
      let newrecord$11 = {...values};
      newrecord$11.contactCivility = value;
      return newrecord$11;
    case "ContactPosition" :
      let newrecord$12 = {...values};
      newrecord$12.contactPosition = value;
      return newrecord$12;
    case "ContactEmail" :
      let newrecord$13 = {...values};
      newrecord$13.contactEmail = value;
      return newrecord$13;
    case "ContactPhoneNumber" :
      let newrecord$14 = {...values};
      newrecord$14.contactPhoneNumber = value;
      return newrecord$14;
    case "ContactMobileNumber" :
      let newrecord$15 = {...values};
      newrecord$15.contactMobileNumber = value;
      return newrecord$15;
    case "LocationLabel" :
      let newrecord$16 = {...values};
      newrecord$16.locationLabel = value;
      return newrecord$16;
    case "LocationRecipient" :
      let newrecord$17 = {...values};
      newrecord$17.locationRecipient = value;
      return newrecord$17;
    case "LocationAddress" :
      let newrecord$18 = {...values};
      newrecord$18.locationAddress = value;
      return newrecord$18;
    case "LocationPostalCode" :
      let newrecord$19 = {...values};
      newrecord$19.locationPostalCode = value;
      return newrecord$19;
    case "LocationCity" :
      let newrecord$20 = {...values};
      newrecord$20.locationCity = value;
      return newrecord$20;
    case "LocationCountry" :
      let newrecord$21 = {...values};
      newrecord$21.locationCountry = value;
      return newrecord$21;
  }
}

let SupplierNewFormLenses_ = {
  get: get,
  set: set
};

let SupplierNewFormLenses = {
  get: get,
  set: set
};

function supplierNewFormInitialValues(shopId) {
  return {
    shopId: shopId,
    companyName: "",
    email: "",
    phoneNumber: "",
    mobileNumber: "",
    intraCommunityVat: "",
    siretNumber: "",
    internalCode: "",
    note: "",
    contactFirstName: "",
    contactLastName: "",
    contactCivility: "NEUTRAL",
    contactPosition: "",
    contactEmail: "",
    contactPhoneNumber: "",
    contactMobileNumber: "",
    locationLabel: "",
    locationRecipient: "",
    locationAddress: "",
    locationPostalCode: "",
    locationCity: "",
    locationCountry: "France"
  };
}

let SupplierNewForm = Form.Make(SupplierNewFormLenses);

let supplierNewFormSchema = [
  {
    TAG: "StringNotEmpty",
    _0: "CompanyName"
  },
  {
    TAG: "Custom",
    _0: "ContactLastName",
    _1: values => {
      let contactFieldsFulfilled = values.contactEmail !== "" || values.contactFirstName !== "" || values.contactMobileNumber !== "" || values.contactPhoneNumber !== "" || values.contactPosition !== "";
      if (values.contactLastName === "" && contactFieldsFulfilled) {
        return {
          TAG: "Error",
          _0: I18n.t("This value must not be empty.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "LocationLabel",
    _1: values => {
      let locationFieldsFulfilled = values.locationRecipient !== "" || values.locationAddress !== "" || values.locationPostalCode !== "" || values.locationCity !== "" || values.locationCountry !== "";
      if (values.locationLabel === "" && locationFieldsFulfilled) {
        return {
          TAG: "Error",
          _0: I18n.t("This value must not be empty.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }
];

function stripEmptyString(string) {
  switch (string) {
    case "" :
    case " " :
      return;
    default:
      return string;
  }
}

function createSupplierMutationVariablesFromFormValues(values) {
  return {
    supplierInput: makeInputObjectInputCreateSupplier(values.companyName, stripEmptyString(values.intraCommunityVat), stripEmptyString(values.siretNumber), stripEmptyString(values.phoneNumber), stripEmptyString(values.mobileNumber), stripEmptyString(values.email), stripEmptyString(values.note), stripEmptyString(values.internalCode), values.shopId, undefined),
    contactsInput: values.contactLastName !== "" ? [makeInputObjectInputCreateSupplierContact(values.contactLastName, stripEmptyString(values.contactFirstName), stripEmptyString(values.contactPosition), stripEmptyString(values.contactEmail), stripEmptyString(values.contactPhoneNumber), stripEmptyString(values.contactMobileNumber), true, values.contactCivility, undefined)] : undefined,
    locationsInput: values.locationLabel !== "" ? [makeInputObjectInputCreateSupplierLocation(values.locationLabel, stripEmptyString(values.locationRecipient), stripEmptyString(values.locationAddress), stripEmptyString(values.locationPostalCode), stripEmptyString(values.locationCity), stripEmptyString(values.locationCountry), [
          "DELIVERY",
          "BILLING"
        ], undefined)] : undefined
  };
}

function SupplierNewPage$SupplierNewFormShopFieldset(props) {
  let shops = Auth.useShops();
  let shopsItems = shops.map(shop => ({
    TAG: "Option",
    key: shop.id,
    label: shop.name,
    value: shop.id
  }));
  let shopsSections = [{
      items: shopsItems
    }];
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Shop"),
    description: I18n.t("Define the shop for which the supplier will be created."),
    children: JsxRuntime.jsx(SupplierNewForm.InputSelect.make, {
      field: "ShopId",
      label: I18n.t("Shop"),
      placeholder: I18n.t("Select a shop"),
      sections: shopsSections
    })
  });
}

let SupplierNewFormShopFieldset = {
  make: SupplierNewPage$SupplierNewFormShopFieldset
};

function SupplierNewPage$SupplierNewFormInformationFieldset$SiretField(props) {
  let match = SupplierNewForm.useField("SiretNumber", undefined, undefined, undefined, undefined);
  let onFocus = match.onFocus;
  return JsxRuntime.jsx(SiretInputField.make, {
    value: match.value,
    errored: Stdlib_Option.isSome(match.error),
    focused: match.focused,
    required: match.required,
    onChange: match.onChange,
    onCompanyFound: props.onCompanyFound,
    onFocus: () => onFocus(),
    onBlur: match.onBlur
  });
}

let SiretField = {
  make: SupplierNewPage$SupplierNewFormInformationFieldset$SiretField
};

function SupplierNewPage$SupplierNewFormInformationFieldset(props) {
  let dispatch = SupplierNewForm.useFormDispatch();
  let onCompanyFound = lookup => {
    if (lookup === undefined) {
      return;
    }
    let company = lookup.company;
    dispatch({
      TAG: "FieldValueChanged",
      _0: "CompanyName",
      _1: param => company.corporateName
    });
  };
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("General information"),
    description: I18n.t("Complete the essential information of your new supplier."),
    children: [
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "CompanyName",
        label: I18n.t("Company name"),
        placeholder: I18n.t("Company name")
      }),
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "Email",
        label: I18n.t("Email address"),
        placeholder: I18n.t("contact@company.com")
      }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(SupplierNewForm.InputPhone.make, {
            label: I18n.t("Home phone"),
            field: "PhoneNumber",
            placeholder: "02 11 22 33 44"
          }),
          JsxRuntime.jsx(SupplierNewForm.InputPhone.make, {
            label: I18n.t("Mobile phone"),
            field: "MobileNumber",
            placeholder: "06 11 22 33 44"
          })
        ]
      }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(SupplierNewForm.InputText.make, {
            field: "IntraCommunityVat",
            label: I18n.t("TVA number"),
            placeholder: "FR 40 123456789",
            copyable: true
          }),
          JsxRuntime.jsx(SupplierNewPage$SupplierNewFormInformationFieldset$SiretField, {
            onCompanyFound: onCompanyFound
          })
        ]
      }),
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "InternalCode",
        label: I18n.t("Internal code"),
        placeholder: I18n.t("Internal code"),
        copyable: true
      })
    ]
  });
}

let SupplierNewFormInformationFieldset = {
  SiretField: SiretField,
  make: SupplierNewPage$SupplierNewFormInformationFieldset
};

function SupplierNewPage$SupplierNewFormLocationFieldset(props) {
  let recipientFieldFilledRef = React.useRef(false);
  let dispatch = SupplierNewForm.useFormDispatch();
  let match = SupplierNewForm.useFormState();
  let values = match.values;
  let onChangeLocationAddress = value => dispatch({
    TAG: "FieldValueChanged",
    _0: "LocationAddress",
    _1: param => value
  });
  let onRequestLocationAutoComplete = address => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationAddress",
      _1: param => address.name
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationPostalCode",
      _1: param => address.postcode
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationCity",
      _1: param => address.city
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "LocationCountry",
      _1: param => address.country
    });
  };
  let defaultlocationRecipientFieldPlaceholder = I18n.t("Company name");
  let locationRecipientFieldPlaceholder = !recipientFieldFilledRef.current && values.companyName !== "" ? values.companyName : defaultlocationRecipientFieldPlaceholder;
  let onFocusLocationRecipientField = () => {
    if (!recipientFieldFilledRef.current && locationRecipientFieldPlaceholder !== defaultlocationRecipientFieldPlaceholder) {
      dispatch({
        TAG: "FieldValueChanged",
        _0: "LocationRecipient",
        _1: param => values.companyName
      });
      recipientFieldFilledRef.current = true;
      return;
    }
  };
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Company address"),
    description: I18n.t("Indicate the supplier's address. It will appear on commercial documents."),
    children: [
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "LocationLabel",
        label: I18n.t("Title"),
        placeholder: I18n.t("Invoicing"),
        hideRequired: true
      }),
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "LocationRecipient",
        label: I18n.t("Recipient"),
        placeholder: locationRecipientFieldPlaceholder,
        hideRequired: true,
        onFocus: onFocusLocationRecipientField
      }),
      JsxRuntime.jsx(AddressComboBoxField.make, {
        addressName: values.locationAddress,
        onInputChange: onChangeLocationAddress,
        onRequestAutoComplete: onRequestLocationAutoComplete
      }),
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "LocationPostalCode",
        label: I18n.t("Postal code"),
        placeholder: I18n.t("Postal code")
      }),
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "LocationCity",
        label: I18n.t("City"),
        placeholder: I18n.t("City")
      }),
      JsxRuntime.jsx(SupplierNewForm.InputCountrySelect.make, {
        field: "LocationCountry"
      })
    ]
  });
}

let SupplierNewFormLocationFieldset = {
  make: SupplierNewPage$SupplierNewFormLocationFieldset
};

function SupplierNewPage$SupplierNewFormContactFieldset(props) {
  let civilityFieldItems = SupplierCivility.options.map(civility => ({
    TAG: "Option",
    key: SupplierCivility.toLongLabel(civility),
    label: SupplierCivility.toLongLabel(civility),
    value: civility
  }));
  let civilityFieldSections = [{
      items: civilityFieldItems
    }];
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Company contact"),
    description: I18n.t("Specify the coordinates of your point of contact within the company to communicate effectively."),
    children: [
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(SupplierNewForm.InputText.make, {
            field: "ContactLastName",
            label: I18n.t("Last name"),
            placeholder: "Dubois",
            hideRequired: true
          }),
          JsxRuntime.jsx(SupplierNewForm.InputText.make, {
            field: "ContactFirstName",
            label: I18n.t("First name"),
            placeholder: "Jean"
          })
        ]
      }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(SupplierNewForm.InputSelect.make, {
            field: "ContactCivility",
            label: I18n.t("Civility"),
            sections: civilityFieldSections
          }),
          JsxRuntime.jsx(SupplierNewForm.InputText.make, {
            field: "ContactPosition",
            label: I18n.t("Employment"),
            placeholder: "Commercial"
          })
        ]
      }),
      JsxRuntime.jsx(SupplierNewForm.InputText.make, {
        field: "ContactEmail",
        label: I18n.t("Email address"),
        placeholder: I18n.t("mikehasford@company.com")
      }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(SupplierNewForm.InputPhone.make, {
            label: I18n.t("Home phone"),
            field: "ContactPhoneNumber",
            placeholder: "02 11 22 33 44"
          }),
          JsxRuntime.jsx(SupplierNewForm.InputPhone.make, {
            label: I18n.t("Mobile phone"),
            field: "ContactMobileNumber",
            placeholder: "06 11 22 33 44"
          })
        ]
      })
    ]
  });
}

let SupplierNewFormContactFieldset = {
  make: SupplierNewPage$SupplierNewFormContactFieldset
};

function SupplierNewPage$SupplierNewFormNoteFieldset(props) {
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Note"),
    description: I18n.t("Add a note."),
    children: JsxRuntime.jsx(SupplierNewForm.InputTextArea.make, {
      field: "Note",
      label: I18n.t("Note")
    })
  });
}

let SupplierNewFormNoteFieldset = {
  make: SupplierNewPage$SupplierNewFormNoteFieldset
};

function SupplierNewPage$SupplierNewFormDiscardButton(props) {
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  if (match[0]) {
    return JsxRuntime.jsx(Button.make, {
      label: I18n.t("Discard"),
      onPress: () => onGoBack()
    });
  } else {
    return JsxRuntime.jsx(SupplierNewForm.CancelButton.make, {
      label: I18n.t("Discard")
    });
  }
}

let SupplierNewFormDiscardButton = {
  make: SupplierNewPage$SupplierNewFormDiscardButton
};

function SupplierNewPage(props) {
  let shopId = props.shopId;
  let supplierShowRoute = props.supplierShowRoute;
  let navigate = Navigation.useNavigate();
  let scope = Auth.useScope();
  let shopId$1;
  if (shopId !== undefined) {
    shopId$1 = shopId;
  } else if (scope.TAG === "Organisation") {
    let shop = scope.activeShop;
    shopId$1 = shop !== undefined ? shop.id : scope.shops[0].id;
  } else {
    shopId$1 = scope._0.id;
  }
  let match = React.useState(() => {});
  let setNotificationError = match[1];
  let notificationError = match[0];
  let onSubmitFailure = error => setNotificationError(param => error);
  let onSubmitSuccess = success => {
    if (success !== undefined) {
      return navigate({
        replace: true
      }, supplierShowRoute(success));
    } else {
      return setNotificationError(param => Request.serverErrorMessage);
    }
  };
  let match$1 = SupplierNewForm.useFormPropState({
    initialValues: supplierNewFormInitialValues(shopId$1),
    schema: supplierNewFormSchema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let match$2 = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let createSupplierMutation = match$2[0];
  let onSubmit = (param, values) => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(createSupplierMutation(undefined, undefined, undefined, undefined, undefined, undefined, undefined, createSupplierMutationVariablesFromFormValues(values))), undefined, param => param.createSupplier.id);
  let actionsBar = JsxRuntime.jsx(ResourceDetailsPage.ActionsBar.make, {
    items: [
      JsxRuntime.jsx(SupplierNewPage$SupplierNewFormDiscardButton, {}),
      JsxRuntime.jsx(SupplierNewForm.SubmitButton.make, {
        label: I18n.t("Save"),
        tone: "success",
        size: "medium",
        onSubmit: onSubmit
      })
    ]
  });
  let notificationBanner;
  if (notificationError !== undefined) {
    let onRequestClose = () => setNotificationError(param => {});
    notificationBanner = JsxRuntime.jsx(ResourceDetailsPage.NotificationBanner.make, {
      value: {
        TAG: "Error",
        _0: notificationError
      },
      onRequestClose: onRequestClose
    });
  } else {
    notificationBanner = null;
  }
  let tmp;
  tmp = scope.TAG === "Organisation" ? JsxRuntime.jsx(SupplierNewPage$SupplierNewFormShopFieldset, {}) : null;
  return JsxRuntime.jsx(SupplierNewForm.Core.Provider.make, {
    children: JsxRuntime.jsxs(ResourceDetailsPage.make, {
      title: I18n.t("New supplier"),
      actionsBar: actionsBar,
      notificationBanner: notificationBanner,
      children: [
        tmp,
        JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(SupplierNewPage$SupplierNewFormInformationFieldset, {}),
            JsxRuntime.jsx(SupplierNewPage$SupplierNewFormLocationFieldset, {}),
            JsxRuntime.jsx(SupplierNewPage$SupplierNewFormContactFieldset, {}),
            JsxRuntime.jsx(SupplierNewPage$SupplierNewFormNoteFieldset, {})
          ],
          space: "xlarge"
        })
      ]
    }),
    propState: [
      match$1[0],
      match$1[1]
    ]
  });
}

let make = SupplierNewPage;

export {
  CreateSupplierMutation,
  SupplierNewFormLenses_,
  SupplierNewFormLenses,
  supplierNewFormInitialValues,
  SupplierNewForm,
  supplierNewFormSchema,
  stripEmptyString,
  createSupplierMutationVariablesFromFormValues,
  SupplierNewFormShopFieldset,
  SupplierNewFormInformationFieldset,
  SupplierNewFormLocationFieldset,
  SupplierNewFormContactFieldset,
  SupplierNewFormNoteFieldset,
  SupplierNewFormDiscardButton,
  make,
}
/* query Not a pure module */
